import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import CodeContent from './CodeContent';
import Tabla from './Tabla';
import TabDinamico from './TabDinamico';
import TablaDocs from './TablaDocs';

function TablaDoc(
  Descripcion,
 Detalles
) {
return { Descripcion,Detalles };
}
const Factura = () => {
  const [t] = useTranslation('global');

  const rows = [
    TablaDoc(t('content.factura.ejemplo1'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACION GRAVADA.json'),
    TablaDoc(t('content.factura.ejemplo2'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON DESCUENTO POR ITEM GRAVADO.json'),
    TablaDoc(t('content.factura.ejemplo3'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACION GRAVADA Y OTROS CARGOS(PROPINA).json'),
    TablaDoc(t('content.factura.ejemplo4'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON ICBPER.json'),
    TablaDoc(t('content.factura.ejemplo5'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACION GRATUITA.json'),
    TablaDoc(t('content.factura.ejemplo6'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACIÓN EXONERADA.json'),
    TablaDoc(t('content.factura.ejemplo7'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON DESCUENTO POR ITEM EXONERADO.json'),
    TablaDoc(t('content.factura.ejemplo8'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON EXONERADO GRATUITO.json'),
    TablaDoc(t('content.factura.ejemplo9'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACIÓN INAFECTO.json'),
    TablaDoc(t('content.factura.ejemplo10'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON OPERACIÓN GRAVADA Y OPERACIÓN EXONERADA.json'),
    TablaDoc(t('content.factura.ejemplo11'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON DETRACCION.json'),
    TablaDoc(t('content.factura.ejemplo12'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON PRIMER ANTICIPO.json'),
    TablaDoc(t('content.factura.ejemplo13'),  '/content/EjemploFacturas/EMISION POR VENTA INTERNA CON TRES EJEMPLOS DE ITEM GRAVADOS.json'),

    
  ];
  return (
    <div id='factura'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" gutterBottom id="facturaTitulo">
        {t('content.factura.titulo')}
      </Typography>
      <Typography variant="h5" gutterBottom id="facturaTitulo">

        {t('content.factura.subtituloJson')}
      </Typography>
      
      <Typography variant="body1" gutterBottom>
        {t('content.factura.subTitulo')}
      </Typography>
      
      <TablaDocs rows={rows} />
      
    </div>

  );
}
export default Factura